import { IconButton } from '@mui/material';
import { GridColDef } from '@mui/x-data-grid-pro';

import { ICDownload } from '@/assets/images';

const actions = (
  onEdit?: (inspectionId?: string) => void,
): Partial<GridColDef> => ({
  field: 'actions',
  headerName: 'Actions',
  width: 100,
  sortable: false,
  filterable: false,
  disableColumnMenu: true,
  renderCell: (params) => (
    <>
      <IconButton
        onClick={(e) => {
          e.stopPropagation();
          onEdit?.(params.row?._id);
        }}
      >
        <ICDownload />
      </IconButton>
    </>
  ),
});

export const inspectionFeesCols = (
  onEdit?: (inspectionId?: string) => void,
) => {
  return {
    actions: () => actions(onEdit),
  };
};
